import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadQuestionnaireAnswersByQuestionnaire,
    loadQuestionnaireById,
    setCurrentQuestionnaire
} from '../../store/participantService';
import { reverseFormatDate } from '../../utils/dateFunctions';

import classes from '../../commonStyles/tables.module.css';

const QuestionnaireRow = ({ row }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // EVENT HANDLERS
    const onEditRow = (row) => {
        dispatch(loadQuestionnaireById(row.id));
        dispatch(loadQuestionnaireAnswersByQuestionnaire(row.id));
        dispatch(setCurrentQuestionnaire(row));
        navigate('/build_questionnaire');
    };

    // RENDER
    return (
        <TableRow
            hover
            className={`${classes.basicRowStripes} ${classes.canOpen}`}
            onClick={() => onEditRow(row)}>
            <TableCell>{row.code}</TableCell>
            <TableCell>{row.title}</TableCell>
            <TableCell>{reverseFormatDate(row.dateCreated)}</TableCell>
            <TableCell>{row.inactive ? 'Inactive' : 'Active'}</TableCell>
        </TableRow>
    );
};

QuestionnaireRow.propTypes = {
    row: PropTypes.object
};

export default QuestionnaireRow;
